import { useEffect } from 'react';
const useDetectAutofill = ({ isToggled, isAutofilled, setOff, setIsAutofilled }) => {
    useEffect(() => {
        if (isAutofilled && isToggled) {
            setOff();
            setIsAutofilled(false);
        }
    }, [isToggled, isAutofilled, setIsAutofilled, setOff]);
};
export default useDetectAutofill;
//# sourceMappingURL=useDetectAutofill.js.map